import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, toRefs, watch } from 'vue';
  import { getItemLocalUrl, getItemUrl } from '@/utils/mediaAsset';
  import { logger } from '@/utils/screenEventsLogger';

  
  import { defineComponent } from 'vue';

  const __default__ = defineComponent({
    name: 'VideoSlide',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    restartSignal: { default: null },
    imageMode: { default: 'cover' },
    itemUrl: null,
    itemId: null,
    itemType: null,
    thumbnail: null
  },
  setup(__props: any) {

const props = __props as { show: boolean, restartSignal: string | null, imageMode: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down', itemUrl: string, itemId: string, itemType: string, thumbnail?: string }

  
  const { show, restartSignal, imageMode, itemUrl, itemId, itemType, thumbnail } = toRefs(props);

  const videoRef = ref<HTMLVideoElement | null>(null);
  const isPlaying = ref(false);

  const videoUrl = computed(() => getItemLocalUrl(itemUrl.value, itemId.value));
  const defaultVideoUrl = computed(() => getItemUrl(itemUrl.value));
  const thumbnailUrl = computed(() => (thumbnail?.value ? getItemUrl(thumbnail.value) : undefined));
  const isWeb = computed(() => {
    return window.isWeb as boolean;
  });
  const isAndroid = computed(() => {
    return window.isAndroid as boolean;
  });

  watch([show, restartSignal], ([newShow, newRestartSignal], [_oldShow, oldRestartSignal]) => {
    if (videoRef.value === null) return;

    if (newShow && newRestartSignal !== oldRestartSignal && newRestartSignal !== null) {
      resetVideo(false);
      isPlaying.value = true;
    }
  });

  watch(show, (newShow, oldShow) => {
    if (videoRef.value === null) return;

    // handle visible to hidden
    if (oldShow === true && newShow === false) {
      resetVideo();
      isPlaying.value = false;
    }
  });

  onMounted(() => {
    if (show.value) {
      playVideo();
    }
  });

  function resetVideo(pause = true) {
    if (videoRef.value === null) return;

    videoRef.value.pause();
    videoRef.value.currentTime = 0;

    if (!pause) {
      playVideo();
    }
  }

  function playVideo() {
    if (videoRef.value === null) return;

    videoRef.value.currentTime = 0;
    const playPromise = videoRef.value.play();

    // browsers released before 2019 may not return a value
    if (playPromise !== undefined) {
      playPromise.then((_) => {}).catch((_error) => {});
    }
  }

  function handleVideoError() {
    logger.addLog(`Failed to load: ${videoUrl.value}`);
  }

  function handleDefaultVideoError() {
    logger.addLog(`Failed to load default: ${defaultVideoUrl.value}`);
  }

  function handlePosterError() {
    logger.addLog(`Failed to load poster: ${thumbnailUrl.value}`);
  }

return { __sfc: true,props, show, restartSignal, imageMode, itemUrl, itemId, itemType, thumbnail, videoRef, isPlaying, videoUrl, defaultVideoUrl, thumbnailUrl, isWeb, isAndroid, resetVideo, playVideo, handleVideoError, handleDefaultVideoError, handlePosterError }
}

})